/**
 * `PageHeader` — intestazione di pagina con titolo, sottotitolo opzionale e uno
 * slot azioni allineato a destra.
 *
 * Il titolo è renderizzato come `<h1>`; passare `titleId` per collegarlo a un
 * `aria-labelledby` sulla sezione contenitore (pattern usato dalle pagine).
 *
 * `titleAdornment` è uno slot opzionale reso **in linea accanto al titolo** (es.
 * un chip di reparto), sulla stessa riga dell'`<h1>`.
 */
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  titleId?: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Contenuto reso in linea accanto al titolo (es. un chip). */
  titleAdornment?: ReactNode;
}

export function PageHeader({
  title,
  titleId,
  subtitle,
  actions,
  titleAdornment,
}: PageHeaderProps) {
  return (
    <div className="ui-page-header">
      <div className="ui-page-header__titles">
        <div className="ui-page-header__title-row">
          <h1 id={titleId}>{title}</h1>
          {titleAdornment}
        </div>
        {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ui-toolbar">{actions}</div>}
    </div>
  );
}
